import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "tw number-input"
};
const _hoisted_2 = {
  class: "flex mt-2 items-center"
};
const _hoisted_3 = {
  class: "w-1/6",
  "data-replay-unmask": ""
};
const _hoisted_4 = {
  class: "flex-1 flex justify-end pl-4 mt-5"
};
const _hoisted_5 = {
  class: "w-1/4 pr-2"
};
const _hoisted_6 = {
  class: "w-1/4 px-2"
};
const _hoisted_7 = {
  class: "w-1/6 px-2",
  "data-replay-unmask": ""
};
const _hoisted_8 = {
  class: "w-1/3 flex justify-end pl-2 mt-5"
};
const _hoisted_9 = {
  class: "flex mt-2"
};
const _hoisted_10 = {
  class: "w-1/2",
  "data-replay-unmask": ""
};
const _hoisted_11 = {
  class: "flex mt-2 gap-4"
};
const _hoisted_12 = {
  class: "w-1/2"
};
const _hoisted_13 = {
  class: "w-1/2"
};
const _hoisted_14 = {
  class: "flex mt-2 items-center gap-4"
};
const _hoisted_15 = {
  class: "w-1/2",
  "data-replay-unmask": ""
};
const _hoisted_16 = {
  key: 2,
  class: "text-sm text-gray-600 mt-1 flex-row"
};
const _hoisted_17 = {
  class: "flex mt-2"
};
const _hoisted_18 = {
  class: "flex-row w-full"
};
import { computed, onMounted, ref, nextTick, isReactive } from 'vue';
import { storeToRefs } from 'pinia';
import LlTextField from '@/components/LlTextField.vue';
import LlDoubleSwitch from '@/components/LlDoubleSwitch.vue';
import { convertToHHSS } from '@/services/utils.js';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useHoursValidation } from '@/composables/useHoursValidation';
import { useTimeEntryDates } from '@/composables/useTimeEntryDates';
export default {
  __name: 'StartEndTime',
  props: {
    form: {
      type: Object,
      required: false
    },
    entryEditService: {
      type: Object,
      required: false
    },
    editEntryState: {
      type: Object,
      required: false
    },
    adjustments: {
      type: Boolean,
      required: false
    },
    showStartStopTime: {
      type: Boolean,
      required: false,
      default: true
    },
    hourHideDetails: {
      type: Boolean,
      required: false,
      default: true
    },
    hourRequired: {
      type: Boolean,
      default: false
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hours-updated', 'update:showStartStopTime'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const props = __props;
    const emit = __emit;

    // Add error state refs
    const startTimeError = ref('');
    const endTimeError = ref('');

    // Add ref for cross-day indicator
    const showCrossDayInfo = ref(false);

    // Handle switch change
    const handleSwitchChange = value => {
      emit('update:showStartStopTime', value);
    };
    onMounted(() => {
      // Validate props
      if (!props.form || typeof props.form !== 'object') {
        console.error('StartEndTime: form prop must be a reactive object');
        return;
      }
      let timeFormat = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
      try {
        if (props.form.endTime && !timeFormat.test(props.form.endTime)) {
          props.form.endTime = convertToHHSS(props.form.endTime);
        }
        if (props.form.startTime && !timeFormat.test(props.form.startTime)) {
          props.form.startTime = convertToHHSS(props.form.startTime);
        }
      } catch (error) {
        console.error('Error converting times on mount:', error);
      }

      // Set default hours to company increment if not already set or is 0
      if (!props.form.hours || props.form.hours === 0) {
        const defaultIncrement = companySettings.value.timeEntryIncrement || 0.1;
        props.form.hours = defaultIncrement;
      }
    });

    // Use the composable for validation
    const {
      hoursRules,
      hasHoursError,
      showDecimalError
    } = useHoursValidation(props.form);
    const timeRules = [value => {
      const timeFormat = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
      var result = timeFormat.test(value) || 'Invalid time format';
      return result;
    }];
    const {
      convertTimeStringToDate,
      handleCrossDayEntry,
      validateTimeEntry
    } = useTimeEntryDates();
    const getStep = props.entryEditService?.getStep || (() => 0.1);
    const changeHours = () => {
      try {
        if (props.form.hours && props.form.hours >= 0) {
          updateEndTime();
        }
        if (props.entryEditService?.updateStepFromEntry) {
          props.entryEditService.updateStepFromEntry(props.form);
        }
        if (props.editEntryState) {
          props.editEntryState.lockCalculatingHoursFromDescription = true;
        }
      } catch (error) {
        console.error('Error in changeHours:', error);
      }
    };
    const parseTime = timeStr => {
      try {
        // Handle empty/null/undefined values
        if (!timeStr || timeStr === '') {
          return null;
        }

        // Handle Date objects
        if (timeStr instanceof Date) {
          return {
            hours: timeStr.getHours(),
            minutes: timeStr.getMinutes()
          };
        }

        // Handle string format
        if (typeof timeStr === 'string') {
          // Check if it's a valid time format first
          if (!/^\d{2}:\d{2}/.test(timeStr)) {
            return null;
          }
          const hours = parseInt(timeStr.slice(0, 2));
          const minutes = parseInt(timeStr.slice(3, 5));
          if (isNaN(hours) || isNaN(minutes) || hours > 23 || minutes > 59) {
            return null;
          }
          return {
            hours,
            minutes
          };
        }

        // Invalid input type
        return null;
      } catch (error) {
        console.error('Error parsing time:', error);
        return null;
      }
    };
    const setDateWithTime = (date, timeStr) => {
      // Handle empty time string
      if (!timeStr || timeStr === '') {
        return null;
      }
      const parsed = parseTime(timeStr);
      if (!parsed) return null;
      const {
        hours,
        minutes
      } = parsed;
      const newDate = new Date(date);
      newDate.setHours(hours);
      newDate.setMinutes(minutes);
      return newDate;
    };
    const updateHoursOnEndTimeChange = () => {
      try {
        // Validate inputs
        if (!props.form || !props.entryEditService) {
          console.error('StartEndTime: Missing required props');
          return;
        }

        // Clear errors first
        startTimeError.value = '';
        endTimeError.value = '';

        // Comprehensive validation
        if (!props.form?.startTime || !props.form?.endTime) {
          endTimeError.value = 'Both start and end times are required';
          return;
        }
        const baseDate = new Date(props.form.date);
        const startTime = convertTimeStringToDate(props.form.startTime, baseDate);
        const endTime = convertTimeStringToDate(props.form.endTime, baseDate);
        if (!startTime || !endTime) {
          endTimeError.value = 'Invalid time format';
          return;
        }

        // Calculate actual hours difference
        let actualEndTime = endTime;
        let crossesDay = false;

        // If end time is before start time, assume it's next day
        if (endTime < startTime) {
          actualEndTime = new Date(endTime);
          actualEndTime.setDate(actualEndTime.getDate() + 1);
          crossesDay = true;
        }

        // Calculate hours based on actual time difference
        const diffMs = actualEndTime.getTime() - startTime.getTime();
        const diffHours = diffMs / (1000 * 60 * 60);

        // Validate that we have a reasonable duration
        if (diffHours < 0 || diffHours > 24) {
          endTimeError.value = 'Invalid time range';
          return;
        }

        // Apply rounding UP based on company increment (Math.ceil to always round up)
        const increment = companySettings.value.timeEntryIncrement || 0.1;
        const roundedHours = Math.ceil(diffHours / increment) * increment;
        const finalHours = Math.max(increment, parseFloat(roundedHours.toFixed(2)));

        // Ensure we have a valid number
        if (isNaN(finalHours)) {
          console.error('finalHours is NaN, aborting update');
          return;
        }

        // Update hours using proper reactivity handling
        updateFormHours(finalHours);

        // Set cross-day indicator
        showCrossDayInfo.value = crossesDay;

        // Call service methods with error boundaries
        if (props.entryEditService?.updateStepFromEntry) {
          try {
            props.entryEditService.updateStepFromEntry(props.form);
          } catch (error) {
            console.error('Error calling updateStepFromEntry:', error);
          }
        }
        if (props.entryEditService?.updateHours) {
          try {
            props.entryEditService.updateHours(props.form);
          } catch (error) {
            console.error('Error calling updateHours:', error);
          }
        }
      } catch (error) {
        console.error('Error in updateHoursOnEndTimeChange:', error);
        endTimeError.value = 'An error occurred while calculating hours';
      }
    };
    const updateFormHours = finalHours => {
      // Use Vue's reactivity system properly
      if (props.form && isReactive(props.form)) {
        props.form.hours = finalHours;

        // Verify the update with nextTick
        nextTick(() => {
          if (props.form.hours !== finalHours) {
            props.form.hours = finalHours;
          }
        });
      } else {
        // Emit an event for non-reactive forms
        emit('hours-updated', finalHours);
      }
    };
    const changeStartTime = () => {
      try {
        const {
          date,
          startTime,
          endTime
        } = props.form;

        // Comprehensive validation
        if (!date) {
          startTimeError.value = 'Date is required';
          return;
        }

        // Handle empty values
        if (!startTime || startTime === '') {
          startTimeError.value = '';
          return;
        }

        // Only process if we have valid time values
        if (startTime && startTime !== '') {
          // Clear previous errors and cross-day info
          startTimeError.value = '';
          endTimeError.value = '';
          showCrossDayInfo.value = false;
          const baseDate = new Date(date);
          const startTimeDate = convertTimeStringToDate(startTime, baseDate);
          if (!startTimeDate) {
            startTimeError.value = 'Invalid time format';
            return;
          }

          // When start time changes, update end time to maintain the current hours duration
          if (props.form.hours && props.form.hours > 0) {
            updateEndTimeFromStartTime();
          } else if (endTime && endTime !== '') {
            // If we have an end time but no hours, calculate hours from the times
            const endTimeDate = convertTimeStringToDate(endTime, baseDate);
            if (endTimeDate) {
              calculateHoursFromTimes(startTimeDate, endTimeDate);
            }
          }
        }
      } catch (error) {
        console.error('Error updating start time:', error);
        startTimeError.value = 'Error updating times';
      }
    };
    function updateEndTimeFromStartTime() {
      if (!props.form.startTime || !props.form.hours) return;
      try {
        const {
          date,
          hours,
          startTime
        } = props.form;
        let currentDate = setDateWithTime(new Date(date), startTime);
        if (!currentDate) {
          console.error('Failed to set date with time');
          return;
        }

        // Calculate end time based on start time + hours
        const endDate = new Date(currentDate.getTime() + hours * 60 * 60 * 1000);

        // Check if end time is on the next day
        showCrossDayInfo.value = endDate.getDate() !== currentDate.getDate();

        // Update end time in HH:MM format
        props.form.endTime = convertToHHSS(endDate);
      } catch (error) {
        console.error('Error in updateEndTimeFromStartTime:', error);
      }
    }
    function calculateHoursFromTimes(startTimeDate, endTimeDate) {
      try {
        // Calculate actual hours difference without using cross-day composable
        let actualEndTime = endTimeDate;
        let crossesDay = false;

        // If end time is before start time, assume it's next day
        if (endTimeDate < startTimeDate) {
          actualEndTime = new Date(endTimeDate);
          actualEndTime.setDate(actualEndTime.getDate() + 1);
          crossesDay = true;
        }

        // Calculate hours based on actual time difference
        const diffMs = actualEndTime.getTime() - startTimeDate.getTime();
        const diffHours = diffMs / (1000 * 60 * 60);

        // Apply rounding UP based on company increment (Math.ceil to always round up)
        const increment = companySettings.value.timeEntryIncrement || 0.1;
        const roundedHours = Math.ceil(diffHours / increment) * increment;
        const finalHours = Math.max(increment, parseFloat(roundedHours.toFixed(2)));

        // Update the hours in the form
        updateFormHours(finalHours);

        // Set cross-day indicator for UI purposes only
        showCrossDayInfo.value = crossesDay;
      } catch (error) {
        console.error('Error calculating hours from times:', error);
      }
    }
    function updateEndTime() {
      if (!props.form.startTime) return;
      try {
        const {
          date,
          hours,
          startTime
        } = props.form;
        let currentDate = setDateWithTime(new Date(date), startTime);
        if (!currentDate) {
          console.error('Failed to set date with time');
          return;
        }
        const endDate = new Date(currentDate.getTime() + hours * 60 * 60 * 1000);

        // Check if end time is on the next day
        showCrossDayInfo.value = endDate.getDate() !== currentDate.getDate();
        props.form.endTime = convertToHHSS(endDate);
      } catch (error) {
        console.error('Error in updateEndTime:', error);
      }
    }
    const fieldLabel = computed(() => props.adjustments ? 'Worked' : 'Hours');
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.isModal ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(LlTextField, {
        modelValue: __props.form.hours,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.form.hours = $event),
        required: "",
        type: "number",
        label: fieldLabel.value,
        step: _unref(getStep)(),
        disabled: __props.form.billed,
        min: 0,
        onChange: _cache[1] || (_cache[1] = $event => changeHours()),
        "data-cy": fieldLabel.value,
        rules: _unref(hoursRules),
        "hide-details": __props.hourHideDetails,
        isRequired: __props.hourRequired,
        class: _normalizeClass({
          'll-text-field--error': _unref(hasHoursError)
        })
      }, null, 8, ["modelValue", "label", "step", "disabled", "data-cy", "rules", "hide-details", "isRequired", "class"])]), _createElementVNode("div", _hoisted_4, [_createVNode(LlDoubleSwitch, {
        "model-value": __props.showStartStopTime,
        "left-label": "Hours",
        "right-label": "Start/Stop",
        "onUpdate:modelValue": handleSwitchChange
      }, null, 8, ["model-value"])])], 512), [[_vShow, !__props.showStartStopTime]]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["flex mt-2 items-center", __props.hourHideDetails ? '' : 'pb-0'])
      }, [_createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
        modelValue: __props.form.startTime,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.form.startTime = $event),
        type: "time",
        label: "Start Time",
        step: 60,
        rules: timeRules,
        "hide-details": __props.hourHideDetails,
        onChange: _cache[3] || (_cache[3] = $event => changeStartTime()),
        "error-messages": startTimeError.value
      }, null, 8, ["modelValue", "hide-details", "error-messages"])]), _createElementVNode("div", _hoisted_6, [_createVNode(LlTextField, {
        modelValue: __props.form.endTime,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => __props.form.endTime = $event),
        type: "time",
        label: "End Time",
        rules: timeRules,
        "hide-details": __props.hourHideDetails,
        step: 60,
        onChange: _cache[5] || (_cache[5] = $event => updateHoursOnEndTimeChange()),
        "error-messages": endTimeError.value
      }, null, 8, ["modelValue", "hide-details", "error-messages"])]), _createElementVNode("div", _hoisted_7, [_createVNode(LlTextField, {
        modelValue: __props.form.hours,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => __props.form.hours = $event),
        required: "",
        type: "number",
        label: fieldLabel.value,
        step: _unref(getStep)(),
        disabled: __props.form.billed,
        min: 0,
        onChange: _cache[7] || (_cache[7] = $event => changeHours()),
        "data-cy": fieldLabel.value,
        rules: _unref(hoursRules),
        "hide-details": __props.hourHideDetails,
        isRequired: __props.hourRequired,
        class: _normalizeClass({
          'll-text-field--error': _unref(hasHoursError)
        })
      }, null, 8, ["modelValue", "label", "step", "disabled", "data-cy", "rules", "hide-details", "isRequired", "class"])]), _createElementVNode("div", _hoisted_8, [_createVNode(LlDoubleSwitch, {
        "model-value": __props.showStartStopTime,
        "left-label": "Hours",
        "right-label": "Start/Stop",
        "onUpdate:modelValue": handleSwitchChange
      }, null, 8, ["model-value"])])], 2), [[_vShow, __props.showStartStopTime]])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(LlTextField, {
        modelValue: __props.form.hours,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => __props.form.hours = $event),
        required: "",
        type: "number",
        label: fieldLabel.value,
        step: _unref(getStep)(),
        disabled: __props.form.billed,
        min: 0,
        onChange: _cache[9] || (_cache[9] = $event => changeHours()),
        "data-cy": fieldLabel.value,
        rules: _unref(hoursRules),
        "hide-details": __props.hourHideDetails,
        isRequired: __props.hourRequired,
        class: _normalizeClass({
          'll-text-field--error': _unref(hasHoursError)
        })
      }, null, 8, ["modelValue", "label", "step", "disabled", "data-cy", "rules", "hide-details", "isRequired", "class"])])])], 512), [[_vShow, !__props.showStartStopTime]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(LlTextField, {
        modelValue: __props.form.startTime,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => __props.form.startTime = $event),
        type: "time",
        label: "Start Time",
        step: 60,
        rules: timeRules,
        "hide-details": __props.hourHideDetails,
        onChange: _cache[11] || (_cache[11] = $event => changeStartTime()),
        "error-messages": startTimeError.value
      }, null, 8, ["modelValue", "hide-details", "error-messages"])]), _createElementVNode("div", _hoisted_13, [_createVNode(LlTextField, {
        modelValue: __props.form.endTime,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => __props.form.endTime = $event),
        type: "time",
        label: "End Time",
        rules: timeRules,
        "hide-details": __props.hourHideDetails,
        step: 60,
        onChange: _cache[13] || (_cache[13] = $event => updateHoursOnEndTimeChange()),
        "error-messages": endTimeError.value
      }, null, 8, ["modelValue", "hide-details", "error-messages"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(LlTextField, {
        modelValue: __props.form.hours,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => __props.form.hours = $event),
        required: "",
        type: "number",
        label: fieldLabel.value,
        step: _unref(getStep)(),
        disabled: __props.form.billed,
        min: 0,
        onChange: _cache[15] || (_cache[15] = $event => changeHours()),
        "data-cy": fieldLabel.value,
        rules: _unref(hoursRules),
        "hide-details": __props.hourHideDetails,
        isRequired: __props.hourRequired,
        class: _normalizeClass({
          'll-text-field--error': _unref(hasHoursError)
        })
      }, null, 8, ["modelValue", "label", "step", "disabled", "data-cy", "rules", "hide-details", "isRequired", "class"])])])], 512), [[_vShow, __props.showStartStopTime]])], 64)), showCrossDayInfo.value && __props.showStartStopTime ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_v_icon, {
        small: ""
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("mdi-information", -1)]))]),
        _: 1
      }), _cache[18] || (_cache[18] = _createTextVNode(" End time is on the next day ", -1))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(LlTextField, {
        modelValue: __props.form.writedown,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => __props.form.writedown = $event),
        type: "number",
        label: "Write-down",
        step: 'any',
        min: 0,
        rules: [() => !__props.form.writedown || __props.form.writedown >= 0 || 'Write-down cannot be negative', () => !__props.form.writedown || !__props.form.hours || parseFloat(__props.form.writedown) <= parseFloat(__props.form.hours) || 'Write-down cannot exceed worked hours'],
        "hide-details": false
      }, null, 8, ["modelValue", "rules"])])], 512), [[_vShow, __props.adjustments]])]);
    };
  }
};